import { render, staticRenderFns } from "./bidSecurity.vue?vue&type=template&id=18c9ac8f&scoped=true"
import script from "./bidSecurity.vue?vue&type=script&lang=js"
export * from "./bidSecurity.vue?vue&type=script&lang=js"
import style0 from "./bidSecurity.vue?vue&type=style&index=0&id=18c9ac8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c9ac8f",
  null
  
)

export default component.exports